export default "__VITE_PUBLIC_ASSET__d103539c__"